import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const setCurrentThemeApiImpl = (_: { theme: string, keyLocalStorage: string, bodyAttr: string }): void => {
    localStorage.setItem(_.keyLocalStorage, _.theme);
    let theme = _.theme;
    if (_.theme === KeyWordLocalization.ChangeThemeUseCaseSystem) {
        theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? KeyWordLocalization.ChangeThemeUseCaseDark : KeyWordLocalization.ChangeThemeUseCaseLight;
    }
    const reduced = theme.replaceAll(KeyWordLocalization.ChangeThemeUseCase, "").toLowerCase();
    document.body.setAttribute(_.bodyAttr, reduced);
}

export default setCurrentThemeApiImpl;